<script>
import SelecForm from '@/components/selecForm.vue';
import common_data from "@/util/common_data.js";
import CarItem from '@/components/carListItem.vue'
import { getDateformat } from '@/util/getDate.js'
import { inspectPhone } from '@/util/verification.js'
import CustomOrderTable from '@/components/customOrderTable/index.vue'

const state_type_list = [
  { id: 'all', name: '全部' },
  { id: 'state_partial_pay', name: '部分付款' },
  { id: 'state_new', name: '待支付' },
  { id: 'state_pay', name: '待发货' },
  { id: 'state_send', name: '待收货' },
  { id: 'state_success', name: '已完成' },
  { id: 'state_cancel', name: '已关闭' },
  { id: 'state_refund', name: '退款' },
  { id: 'state_unevaluate', name: '未评价' },
]

const breakdown_status_list = [
  { id: '', name: '全部' },
  { id: 'PENDING', name: '待处理' },
  { id: 'PROCESSING', name: '处理中' },
  { id: 'SUCCESS', name: '分账成功' },
  { id: 'FAIL', name: '分账失败' },
]

export default {
  components: {
    SelecForm,
    CarItem,
    CustomOrderTable,
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      let phone = inspectPhone(value)
      if (!phone) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      getDateformat,
      form_search_style: common_data.form_search_style,
      form: [
        { type: 'input', label: '订单编号', key: 'pay_sn', placeholder: '请输入订单编号' },
        { type: 'select', label: '订单状态', key: 'state_type', placeholder: '请选择', list: state_type_list, d_value: "all" },
        { type: 'input', label: '车辆信息', key: 'goods_name', placeholder: '请输入车辆信息' },
        { type: 'select', label: '分账状态', key: 'split_type', placeholder: '请选择', list: breakdown_status_list, d_value: "" },
        { type: 'datetimerange', label: '下单时间', key: 'create_time' },
        { type: 'datetimerange', label: '支付时间', key: 'pay_time' },
        { type: 'datetimerange', label: '发货时间', key: 'delay_time' },
        { type: 'datetimerange', label: '完成时间', key: 'finish_time' },
      ],
      thead_list: [
        { key: "car_info", label: "车辆信息", width: '250px' },
        { key: "supplier_price", label: "商品金额明细", width: '150px' },
        { key: "discount_price", label: "优惠金额明细", width: '180px' },
        { key: "deposit_price", label: "定金实付/应付", width: '150px' },
        { key: "order_pay_price", label: "订单支付金额", width: '150px' },
        { key: "payment_code", label: "支付方式", width: '100px' },
        { key: "order_status", label: "订单状态", width: '80px' },
        { key: "breakdown_details", label: "分账明细", width: '150px' },
        { key: "breakdown_status", label: "分账状态", width: '80px' },
        { key: "breakdown_time", label: "分账时间", width: '150px' },
        { key: "order_type", label: "订单类型", width: '80px' },
        { key: "cz", label: "操作", width: '100px', fixed: 'right' },
      ],
      order_data_config: {
        page: 1,
        rows: 10,
        list: [],
        total: 0
      },
      payment_code: {
        '10': '微信支付', '20': '支付宝支付', '30': '华为支付', '40': '余额支付', '50': '会员卡支付', '60': '抖音支付', '70': '百度支付', '80': '银行转账'
      },
      order_status: {
        0: "已取消",
        10: "待支付",
        20: "待发货",
        30: "待收货",
        40: "已完成",
        50: "尾款支付",
      },
      order_type: {
        0: "普通订单",
        1: "特价订单",
        2: "套餐订单",
      },
      breakdown_status: [
        { status: 'PENDING', name: '待处理' },
        { status: 'PROCESSING', name: '处理中' },
        { status: 'SUCCESS', name: '分账成功' },
        { status: 'FAIL', name: '分账失败' },
      ],
      shipment_config: {
        show: false,
        order: {},
        deliver_name: '',
        deliver_phone: '',
        remark: '',
        tracking_time: ''
      },
      shipment_rules: {
        deliver_name: [{ required: true, message: '请输入发货人姓名', trigger: 'blur' }],
        deliver_phone: [{ required: true, message: '请输入发货人手机号', trigger: 'blur' }, { validator: checkPhone, message: '请输入正确的手机号', trigger: 'blur' }],
        tracking_time: [{ required: true, message: '请选择发货时间', trigger: 'blur' }],
      },
      discount_order_config: {
        show: false,
        order: {},
      },
      table_scroll_config: {
        show: false,
        scroll_width: '',
        bar_width: '',
        p_bottom: 0,
        scroll_height: 6,
        spacing: 10
      }
    };
  },
  created() {
    this.getOrderList()
  },
  mounted() {
    let router_view = document.querySelector('#order_list_main')
    router_view.addEventListener('scroll', this.$refs.order_table.initTableVirtualScrollBar)
  },
  beforeDestroy() {
    let router_view = document.querySelector('#order_list_main')
    if(router_view)router_view.removeEventListener('scroll', this.$refs.order_table.initTableVirtualScrollBar)
  },
  methods: {
    getOrderList() {
      let obj = {
        page: this.order_data_config.page,
        rows: this.order_data_config.rows,
        state_type: 'all'
      }
      if (this.$refs.select_form) {
        obj = { ...obj, ...this.$refs.select_form.deal() }
      }
      this.$axios.post(this.$api.order.list, obj).then(res => {
        if (res.code == 0) {
          res.result.list.map(o => {
            o.is_choose = false;
            o.is_discount_btn = false
            let is_discount = false
            let is_vip = o.extend_user.is_chache_vip
            for (let i = 0; i < o.extend_order_goods.length; i++) {
              let g = o.extend_order_goods[i]
              if (!g.package_id) {
                g.item_info.last_raise_price = is_vip ? g.item_info.vip_raise_price : g.item_info.raise_price
                if (Number(g.item_info.internal_price) > 0) is_discount = true
              }
              if (g.package_id) {
                for (let j = 0; j < g.package_item_list.length; j++) {
                  let g1 = g.package_item_list[j]
                  g1.last_raise_price = is_vip ? g1.vip_raise_price : g1.raise_price
                  if (Number(g1.internal_price) > 0) is_discount = true
                }
              }
            }
            // || o.state == 50
            if ((o.state == 10 ) && is_discount) {
              o.is_discount_btn = true
            }
          })
          this.order_data_config.list = res.result.list;
          this.order_data_config.total = res.result.total_number;
        }
      })
    },
    changeOrderPage(val, status) {
      if (status == 0) {
        this.order_data_config.rows = val;
      } else {
        this.order_data_config.page = val;
      }
      this.getOrderList();
    },
    getSelectOrder() {
      this.order_data_config.page = 1
      this.getOrderList()
    },
    getBreakdownStatus(status) {
      return this.breakdown_status.find(o => o.status == status)?.name || '--'
    },
    openShipmentForm(order) {
      this.shipment_config = {
        show: false,
        order: {},
        deliver_name: '',
        deliver_phone: '',
        remark: '',
        tracking_time: ''
      }
      this.shipment_config.show = true
      this.shipment_config.order = order
    },
    confirmShipment() {
      this.$refs.shipment_form.validate((valid) => {
        if (valid) {
          this.$axios.post(this.$api.order.setSend, {
            id: this.shipment_config.order.id,
            deliver_name: this.shipment_config.deliver_name,
            deliver_phone: this.shipment_config.deliver_phone,
            remark: this.shipment_config.remark,
            tracking_time: Math.floor(this.shipment_config.tracking_time / 1000)
          }).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '发货成功',
                type: 'success'
              })
              this.shipment_config.show = false
              this.getOrderList()
            }
          })
        }
      })
    },
    openDiscountForm(order) {
      this.discount_order_config = {
        show: false,
        order: {},
      }
      order.extend_order_goods.forEach(goods => {
        if (!goods.package_id) {
          this.$set(goods.item_info, 'discount_pay_price', Number(goods.discount_pay_price) || '')
          this.$set(goods.item_info, 'discount_raise_price', Number(goods.discount_raise_price) || '')
        }
        if (goods.package_id) {
          let min = 0
          for (let i = 0; i < goods.package_item_list.length; i++) {
            let car = goods.package_item_list[i]
            min += (Number(car.internal_price) || Number(car.price))
          }
          this.$set(goods, 'min', min)
          this.$set(goods, 'discount_pay_price', Number(goods.discount_pay_price) || '')
        }

      })
      this.discount_order_config.show = true
      this.discount_order_config.order = order
    },
    confirmDiscount() {
      let data = this.discount_order_config.order
      let obj = {
        revise_goods: []
      }
      let flag = ''
      data.extend_order_goods.forEach(goods => {
        let p = {
          id: goods.id
        }
        if (!goods.package_id) {
          if (Number(goods.discount_pay_price) > Number(goods.item_info.internal_price)) {
            flag = '商品优惠金额不可大于车辆的销售底价'
          }
          if (Number(goods.discount_raise_price) > Number(goods.item_info.last_raise_price)) {
            flag = '加价优惠金额不能大于加价金额'
          }
          p.discount_pay_price = goods.item_info.discount_pay_price || 0
          p.discount_raise_price = goods.item_info.discount_raise_price || 0
        }
        if (goods.package_id) {
          if (Number(goods.discount_pay_price) < goods.min) {
            flag = '套餐优惠金额不能小于套餐内车辆的销售底价'
          }
          p.discount_pay_price = goods.discount_pay_price || 0
        }
        obj.revise_goods.push(p)
      })
      if (flag) {
        this.$message.warning(flag)
        return
      }
      this.$axios.post(this.$api.order.changePrice, obj).then(res => {
        if (res.code == 0) {
          this.$message.success('修改成功')
          this.discount_order_config.show = false
          this.getOrderList()
        }
      })
    },
    confirmReceipt(order) {
      this.$axios.post(this.$api.order.confirmReceipt, {
        id: order.id
      }).then(res => {
        if (res.code == 0) {
          this.$message.success('确认收货成功')
          order.is_show_popover = false
          this.getOrderList()
        }
      })
    },
  },
};
</script>
<template>
  <el-main id="order_list_main">
    <SelecForm ref="select_form" @search="getSelectOrder" :form_style="form_search_style" :form="form"></SelecForm>
    <div style="height: 16px;"></div>
    <CustomOrderTable ref="order_table" :head="thead_list" :data="order_data_config.list" :is_choose="true">
      <!-- 信息行 -->
      <template #_row="{ row }">
        <div class="content">订单编号：{{row.pay_sn}}</div>
        <div class="content">下单时间：{{getDateformat(row.create_time)}}</div>
        <div class="content">支付时间：{{row.payment_time ? getDateformat(row.payment_time) : '--'}}</div>
        <div class="content">发货时间：{{row.delay_time ? getDateformat(row.delay_time) : '--'}}</div>
        <div class="content">完成时间：{{row.finnshed_time ? getDateformat(row.finnshed_time) : '--'}}</div>
      </template>
      <template #car_info="{ row }">
        <div class="table_cell_box">
          <div class="cell_row_info center" v-for="car in row.extend_order_goods" :key="car.id">
            <CarItem v-if="!car.package_id" :car="car.item_info" height="66px"></CarItem>
            <div class="table_cell_box" v-if="car.package_id">
              <div class="cell_row_info center" v-for="p_item in car.package_item_list" :key="p_item.id">
                <CarItem :car="p_item" height="66px"></CarItem>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #supplier_price="{ row }">
        <div class="table_cell_box">
          <div class="cell_row_info center" v-for="car in row.extend_order_goods" :key="car.id">
            <div class="center_info" v-if="!car.package_id">
              <div class="desc" v-if="!row.extend_user.is_chache_vip">零售价:¥{{car.item_info.price}}</div>
              <div class="desc" v-if="row.extend_user.is_chache_vip">会员价:¥{{car.item_info.original_price}}</div>
              <div class="desc">税金金额:¥{{car.tax_price}}</div>
            </div>
            <div class="table_cell_box" v-if="car.package_id">
              <div class="cell_row_info center" v-for="p_item in car.package_item_list" :key="p_item.id">
                <div class="center_info">
                  <div class="desc">会员价:¥{{p_item.price}}</div>
                  <div class="desc">税金金额:¥{{p_item.tax_price || '0.00'}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #discount_price="{ row }">
        <div class="table_cell_box">
          <div class="cell_row_info center" v-for="car in row.extend_order_goods" :key="car.id">
            <div class="center_info" v-if="!car.package_id">
              <div class="desc">商品优惠金额:¥{{car.discount_pay_price}}</div>
            </div>
            <div class="table_cell_box" v-if="car.package_id">
              <div class="cell_row_info center" v-for="p_item in car.package_item_list" :key="p_item.id">
                <div class="center_info">
                  <div class="desc">商品优惠金额:¥{{(p_item.discount_price || 0).toFixed(2)}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #deposit_price="{ row }">
        <div class="table_cell_box">
          <div class="desc" v-if="row.state > 10">
            <span>¥{{row.deposit_price}}</span>/<span>¥{{row.deposit_price}}</span>
          </div>
          <div class="desc" v-else><span>¥0.00</span>/<span>¥{{row.deposit_price}}</span></div>
        </div>
      </template>
      <template #order_pay_price="{ row }">
        <div class="table_cell_box">
          <div class="desc" v-if="Number(row.revise_amount)">¥{{ row.revise_amount }}</div>
          <div class="desc" v-else>¥{{ (Number(row.real_pay_price) + Number(row.final_payment_amount) + Number(row.tax_price)).toFixed(2) }}</div>
        </div>
      </template>
      <template #payment_code="{ row }">
        <div class="table_cell_box">
          <div class="desc">{{payment_code[row.payment_code] || '--'}}</div>
        </div>
      </template>
      <template #order_status="{ row }">
        <div class="table_cell_box">
          <div class="desc">{{order_status[row.state] || '--'}}</div>
        </div>
      </template>
      <template #breakdown_details="{ row }">
        <div class="table_cell_box">
          <div class="cell_row_info center">
            <div class="center_info">
              <div class="desc">分账金额:¥{{row.split_total_amount}}</div>
            </div>
          </div>
        </div>
      </template>
      <template #breakdown_status="{ row }">
        <div class="table_cell_box">
          <div class="desc">{{ getBreakdownStatus(row.split_status) }}</div>
        </div>
      </template>
      <template #breakdown_time="{ row }">
        <div class="table_cell_box">
          <div class="desc">{{ row.split_time ? getDateformat(row.split_time) : '--' }}</div>
        </div>
      </template>
      <template #order_type="{ row }">
        <div class="table_cell_box">
          <div class="desc">{{order_type[row.order_type] || '--'}}</div>
        </div>
      </template>
      <template #cz="{ row }">
        <div class="table_cell_box">
          <div class="desc">
            <el-button type="text" size="mini" @click="$router.push(`/order/orderDetail/${row.id}`)">查看</el-button>
            <!-- <el-button type="text" size="mini" v-if="row.state == 20" @click="openShipmentForm(row)">发货</el-button>
            <el-button type="text" size="mini" v-if="row.is_discount_btn"
              @click="openDiscountForm(row)">订单优惠</el-button>
            <el-popover placement="top" width="160" v-model="row.is_show_popover">
              <p style="line-height: 40px">
                <i class="el-icon-info" style="color: #e6a23c"></i>是否确认收货？
              </p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="row.is_show_popover = false">取消</el-button>
                <el-button type="primary" size="mini" @click="confirmReceipt(row)">确定</el-button>
              </div>
              <el-button style="margin: 0 10px;" v-if="row.state == 30" slot="reference" type="text"
                size="mini">确认收货</el-button>
            </el-popover> -->
          </div>
        </div>
      </template>
    </CustomOrderTable>
    <Paging :total="order_data_config.total" :page="order_data_config.page" :pageNum="order_data_config.rows"
      @updatePageNum="changeOrderPage"></Paging>
    <!-- 订单发货弹窗 -->
    <el-dialog title="订单发货" :visible.sync="shipment_config.show" width="500px">
      <el-form :model="shipment_config" :rules="shipment_rules" label-width="100px" ref="shipment_form">
        <el-form-item label="订单号">
          {{ shipment_config.order.pay_sn }}
        </el-form-item>
        <el-form-item label="发货时间" prop="tracking_time">
          <el-date-picker v-model="shipment_config.tracking_time" type="datetime" placeholder="选择发货时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="发货司机" prop="deliver_name">
          <el-input v-model="shipment_config.deliver_name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="发货手机号" prop="deliver_phone">
          <el-input v-model="shipment_config.deliver_phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="shipment_config.remark" type="textarea" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shipment_config.show = false">取 消</el-button>
        <el-button type="primary" @click="confirmShipment">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 订单优惠弹窗 -->
    <el-dialog title="订单优惠" :visible.sync="discount_order_config.show" width="800px">
      <el-table :data="discount_order_config.order.extend_order_goods"
        :header-cell-style="{ 'background-color': '#F8F9FA' }">
        <el-table-column label="商品信息" prop="goods_name" width="300px" align="center">
          <template v-slot="{ row }">
            <CarItem v-if="!row.package_id" :car="row.item_info" height="66px"></CarItem>
            <div v-for="p_item in row.package_item_list" :key="p_item.id">
              <CarItem :car="p_item" height="66px"></CarItem>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品优惠金额" prop="discount_amount" align="center">
          <template v-slot="{ row }">
            <el-input v-if="!row.package_id" :disabled="Number(row.item_info.internal_price) <= 0"
              v-model="row.item_info.discount_pay_price" placeholder="请输入"></el-input>
            <div v-if="row.package_id" class="center">
              <el-input v-model="row.discount_pay_price" placeholder="请输入"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="加价优惠金额" prop="discount_amount" align="center">
          <template v-slot="{ row }">
            <el-input v-if="!row.package_id" :disabled="Number(row.item_info.last_raise_price) <= 0"
              v-model="row.item_info.discount_raise_price" placeholder="请输入"></el-input>
            <div v-if="row.package_id" class="center">--</div>
          </template>
        </el-table-column>
        <el-table-column label="销售底价" prop="discount_amount" align="center">
          <template v-slot="{ row }">
            <div v-if="!row.package_id">¥{{ row.item_info.internal_price }}</div>
            <div v-if="row.package_id" class="center">¥{{ row.min }}</div>
          </template>
        </el-table-column>
        <el-table-column label="加价金额" prop="discount_amount" align="center">
          <template v-slot="{ row }">
            <div v-if="!row.package_id">¥{{ row.item_info.last_raise_price }}</div>
            <div v-if="row.package_id" class="center">--</div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="discount_order_config.show = false">取 消</el-button>
        <el-button type="primary" @click="confirmDiscount">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>
<style lang="less" scoped>
.el-main {
  width: 100%;
  background: #fff;
  height: 100%;
  &::-webkit-scrollbar {
    width: 4px;
  }
}
</style>
